module.exports = __webpack_public_path__ + "static/media/empty-card-icon-120x120.ad61bac9.svg";